export default class RemoveFilesCommentRequest  {
	/**
	 * * Айди таска в котором искаться файлы
	 */
	CommentId!: number;
	/**
	 * * Айди файлов которые будут удалены
	 */
	FilesIds!: Array<number>;
	constructor(obj?: Partial<RemoveFilesCommentRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
